export enum FlightShopWidgetTemplates {
  HOME = 'home',
  APP = 'app',
  MODIFY = 'modify'
}
